import { render, staticRenderFns } from "./OrgIndex.vue?vue&type=template&id=bf3bdeaa&scoped=true"
import script from "./OrgIndex.vue?vue&type=script&lang=js"
export * from "./OrgIndex.vue?vue&type=script&lang=js"
import style0 from "./OrgIndex.vue?vue&type=style&index=0&id=bf3bdeaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3bdeaa",
  null
  
)

export default component.exports